//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { axiosPost } from '../../axios/axios.js'
import FilesGroup from '../../components/File/FilesGroup'
import FilesField from '../../components/File/FilesField.vue'
import WaybillFlightPhotos from '../Waybill/WaybillFlightPhotos.vue'

export default ({
  components: {
    FilesField,
    WaybillFlightPhotos
  },
  props: {
    sourceCategory: {
      type: Object,
      default: null
    },
    report: {
      type: Object,
      default: null
    },
    serviceObject: {
      type: Object,
      default: null
    }
  },
  data: function () {
    return {
      category: null,
      photosFromReportIds: [],

      expandedReportPhotos: true,
      loading: false
    }
  },
  computed: {

  },
  mounted: function () {
    this.createCategory()
  },
  methods: {
    createCategory: function () {
      const sourceConfig = {
        objectId: this.serviceObject.id,
        uploadURL: '/service/delta/document/upload',
        removeURL: '/service/delta/document/deleteFromObject',
        removeDelayed: true,
        removeRelationships: true
      }
      this.category = new FilesGroup({
        categoryKey: 'serviceObjectPhoto',
        key: 'serviceObjectPhoto',
        title: 'ФОТОГРАФИИ ОБЪЕКТА',
        documentType: 'serviceObjectPhoto',
        property: 'serviceObjectPhoto',
        documents: this.sourceCategory.files.map(file => file.document),
        sourceConfig
      })
    },
    getReportPhotos: function () {
      const documentsIds = []
      // Фото из раздела "Фотографии и видео" отчёта
      this.report.documents.forEach(document => {
        if (document.contentType.includes('image') && (this.report.activePhotoCategories.includes(document.category) || document.category.includes('checkList'))) {
          documentsIds.push(document.id)
        }
      })

      // Убираем одинаковые фото
      const uniqueDocumentsIds = [...new Set(documentsIds)]

      const currentDocumentsIds = this.category ? this.category.files.map(file => file.document.id) : []

      return uniqueDocumentsIds.map(documentId => {
        return {
          url: '/service/delta/document/read?id=' + documentId,
          name: documentId + ', ' + new Date().toLocaleString(),
          id: documentId,
          selectable: !currentDocumentsIds.includes(documentId)
        }
      })
    },
    onSelectPhoto: function (value) {
      this.photosFromReportIds = value
    },
    onSave: function () {
      this.loading = true
      this.save().then(result => {
        if (result) {
          this.$emit('save')
        } else {
          this.loading = false
        }
      })
    },
    save: async function () {
      try {
        await this.category.saveFilesChanges({
          notify: true,
          target: this
        })

        const bodyFormData = new FormData()
        bodyFormData.set('parentId', this.serviceObject.id)
        bodyFormData.set('documentProperty', 'serviceObjectPhoto')

        const filesConf = this.photosFromReportIds.map(id => {
          return { id }
        })
        bodyFormData.set('filesConf', JSON.stringify(filesConf))

        if (this.photosFromReportIds.length > 0) {
          await axiosPost({
            url: '/service/delta/document/add',
            data: bodyFormData,
            onSuccess: (response) => {
              this.$q.notify({
                type: 'positive',
                message: 'Прикреплено из отчета: ' + this.photosFromReportIds.length,
                progress: true,
                timeout: 3000
              })
            }
          })
        }

        return true
      } catch (err) {
        this.$q.notify({
          type: 'negative',
          message: err.message,
          progress: true,
          timeout: 8000
        })
        return false
      }
    },
    onClose: function () {
      this.$emit('close')
    },
    onRemoveFile: function ({ file: fileWrapper, filesGroup }) {
      filesGroup.removeFile(fileWrapper)
    }
  }
})
